import Tabs from '@/components/Tabs';
import { MainContents } from '@/components/MainContents';
import type { AnalysisSearch } from '@/routes/agent_spa/agent/analysis';
import AnalysisProgressTab from './AnalysisProgressTab';
import AnalysisInsightTab from './AnalysisInsightTab';

type Props = {
  search: AnalysisSearch;
  onUpdateSearch: (updates: Partial<AnalysisSearch>) => void;
};

const TAB_ITEMS = [
  { id: 'progress' as const, label: '進捗分析' },
  { id: 'insight' as const, label: 'インサイト' },
];

/**
 * 分析画面のシェル
 * search.tab に応じて「進捗分析」「インサイト」のいずれかのタブを描画する。
 */
export default function AnalysisPage({ search, onUpdateSearch }: Props) {
  const activeTab = search.tab;

  return (
    <MainContents>
      <div className="-mx-lg -mt-sm mb-md bg-white">
        <Tabs
          items={TAB_ITEMS.map((tab) => ({
            label: tab.label,
            current: activeTab === tab.id,
            onClick: () => onUpdateSearch({ tab: tab.id, page: 1 }),
          }))}
        />
      </div>

      {activeTab === 'progress' && (
        <AnalysisProgressTab search={search} onUpdateSearch={onUpdateSearch} />
      )}
      {activeTab === 'insight' && (
        <AnalysisInsightTab search={search} onUpdateSearch={onUpdateSearch} />
      )}
    </MainContents>
  );
}
